import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Package, Loader2, CheckCircle, ArrowLeft, Truck, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";

const ShopSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    const poll = async (attempts = 0) => {
      if (attempts >= 5) { setStatus("timeout"); return; }
      try {
        const res = await axios.get(`${API}/shop/checkout/status/${sessionId}`);
        if (res.data.payment_status === "paid") { setStatus("paid"); return; }
        if (res.data.status === "expired") { setStatus("expired"); return; }
        setTimeout(() => poll(attempts + 1), 2000);
      } catch {
        setTimeout(() => poll(attempts + 1), 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="shop-success-page">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="max-w-md w-full">
        <Card>
          <CardContent className="p-8 text-center space-y-4">
            {status === "checking" && (
              <>
                <Loader2 className="w-12 h-12 mx-auto animate-spin text-primary" />
                <h2 className="font-heading text-xl font-bold text-charcoal">Vérification du paiement...</h2>
                <p className="text-muted-foreground text-sm">Merci de patienter quelques secondes</p>
              </>
            )}
            {status === "paid" && (
              <>
                <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center">
                  <CheckCircle className="w-8 h-8 text-green-600" />
                </div>
                <h2 className="font-heading text-xl font-bold text-charcoal">Commande confirmée !</h2>
                <p className="text-muted-foreground text-sm">Merci pour votre achat. Vous recevrez une notification avec les détails de livraison.</p>
                <div className="flex gap-3 justify-center pt-2">
                  <Link to="/shop/orders"><Button className="rounded-full gap-2"><Package className="w-4 h-4" /> Mes commandes</Button></Link>
                  <Link to="/shop"><Button variant="outline" className="rounded-full">Continuer</Button></Link>
                </div>
              </>
            )}
            {(status === "expired" || status === "timeout" || status === "error") && (
              <>
                <Package className="w-12 h-12 mx-auto text-muted-foreground/30" />
                <h2 className="font-heading text-xl font-bold text-charcoal">Paiement non confirmé</h2>
                <p className="text-muted-foreground text-sm">Le paiement n'a pas abouti ou a expiré.</p>
                <Link to="/shop"><Button className="rounded-full gap-2"><ArrowLeft className="w-4 h-4" /> Retour à la boutique</Button></Link>
              </>
            )}
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default ShopSuccessPage;
